import React from "react";

const DaySelectOptions = () => {
  return (
    <>
      {Array.from({ length: 31 }, (_, i) => (
        <option key={i + 1} value={i + 1}>
          {i + 1} day{i + 1 > 1 ? "s" : ""}
        </option>
      ))}
    </>
  );
};

export default DaySelectOptions;
